import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./Home"; // Updated to include About content
import About from "./pages/About"; // Import the new About component
import Prices from "./pages/Prices"; // Create this component
import FAQ from "./pages/FAQ"; // Create this component
import Contact from "./pages/Contact"; // Create this component
import Gallery from "./pages/Gallery"; // Import the new Gallery component
import Services from "./pages/Services"; // Import the new Services component
import ChemicalPeels from "./pages/ChemicalPeels"; // Import the Chemical Peels detail page
import BioRePeel from "./pages/BioRePeel"; // Import the BioRePeel detail page
import MandelicAcidPeel from "./pages/MandelicAcidPeel"; // Import the Mandelic Acid Peel detail page
import AzelaicAcidPeel from "./pages/AzelaicAcidPeel"; // Import the Azelaic Acid Peel detail page
import GlowPeel from "./pages/GlowPeel"; // Import the Glow Peel detail page
import Microneedling from "./pages/Microneedling"; // Import the Microneedling detail page
import MicroneedlingBioRePeel from "./pages/MicroneedlingBioRePeel"; // Import the Microneedling + BioRePeel detail page
import ErrorBoundary from "./ErrorBoundary"; // Import the error boundary
import './i18n'; // Import i18n configuration
import './App.css';

function App() {
  return (
    <ErrorBoundary>
      <Router
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true,
        }}
      >
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/chemical-peels" element={<ChemicalPeels />} />
            <Route path="/services/biorepeel" element={<BioRePeel />} />
            <Route path="/services/mandelic-acid-peel" element={<MandelicAcidPeel />} />
            <Route path="/services/azelaic-acid-peel" element={<AzelaicAcidPeel />} />
            <Route path="/services/glow-peel" element={<GlowPeel />} />
            <Route path="/services/microneedling" element={<Microneedling />} />
            <Route path="/services/microneedling-biorepeel" element={<MicroneedlingBioRePeel />} />
            <Route path="/prices" element={<Prices />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
      </Router>
    </ErrorBoundary>
  );
}

export default App;
